import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ServiceAreaTypeMultipleSelectSectionCtrl implements IController {
  serviceAreaTypes: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  /* @ngInject */
  constructor(private ServiceAreaConstants) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.ServiceAreaConstants.serviceTypes;
    }
  }

  $onChanges(changes) {
    if (changes.serviceAreaTypes) {
      this.selectedKeys = [];
      _.forEach(this.serviceAreaTypes, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      serviceAreaTypes: isSelected ? _.concat(this.serviceAreaTypes, [option]) :
        _.filter(this.serviceAreaTypes, (type) => {
          return type !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({serviceAreaTypes: []});
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreaTypeMultipleSelectSection', {
    bindings: {
      serviceAreaTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./service-area-type-multiple-select-section.html').default,
    controller: ServiceAreaTypeMultipleSelectSectionCtrl
  });
